import { useCallback, useEffect, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import * as auth from '../../../app/modules/auth/redux/AuthRedux'
import { useDispatch } from 'react-redux';

type Props = {
    id: string
    className: string
    disabled: boolean
    loading: boolean
    spanClassName: string
    text: string
    actionName: string
}



export const ReCaptchaButton: React.FC<Props> = ({ id, className, disabled, loading, spanClassName, text, actionName }) => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const dispatch = useDispatch()
    const [subLoading, setSubLoading] = useState(false)

    const handleReCaptchaVerify = useCallback(async () => {
        setSubLoading(true);
        if (!executeRecaptcha) {
            setSubLoading(false);
            return false;
        }

        const token = await executeRecaptcha(actionName);
        dispatch(auth.actions.setHumanVerification(token))
        document.getElementById(id+"sbmt")?.click()
        setSubLoading(false);
    }, [executeRecaptcha]);

    // You can use useEffect to trigger the verification as soon as the component being loaded
    // useEffect(() => {
    //   handleReCaptchaVerify();
    // }, [handleReCaptchaVerify]);

    return (
        <>
            <button
                type='button'
                id={id}
                className={className}
                disabled={disabled || subLoading}
                onClick={handleReCaptchaVerify}
            >
                {(!loading && !subLoading) && <span className={spanClassName}>{text}</span>}
                {(loading || subLoading) && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                        Bekleyin...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                )}
            </button>
            <button hidden type='submit' id={id + "sbmt"}></button>
        </>
    );
};